import convertValueToString from '../../components/transformData/convertValueToString'
import { FieldType } from '@wix/wix-data-schema-types'

const to12HourFormat = (value: Date): string => value.toLocaleTimeString('en-US', {
  hour: '2-digit',
  minute: '2-digit',
  second: '2-digit',
  hour12: true,
  timeZone: 'UTC',
})

const formatTime = (value: unknown): string => {
  if (!value) {
    return ''
  }
  const date = new Date(`1970-01-01T${String(value).trim()}Z`)
  if (Number.isNaN(date.getTime())) {
    return ''
  }
  return to12HourFormat(date)
}

const formatDateTime = (value: unknown): string => {
  if (!value) {
    return ''
  }
  const date = new Date(String(value).trim())
  if (Number.isNaN(date.getTime())) {
    return ''
  }
  const datePart = date.toISOString().slice(0, 10)
  const timePart = to12HourFormat(date)
  return `${datePart} ${timePart}`
}

const formatFieldValue = <T>(value: T, type: FieldType) => {
  if (type === FieldType.text) {
    return convertValueToString(value)
  }
  if (type === FieldType.time) {
    return formatTime(value)
  }
  if (type === FieldType.dateTime) {
    return formatDateTime(value)
  }
  return value
}

export default formatFieldValue

